import { GlowLogo } from '../../shared/glow-logo';
import { IntroAura, type IntroAuraVariant } from './intro-aura';

interface IntroMarkProps {
  variant: IntroAuraVariant;
}

/**
 * Small composite for intro screens 2-5: page 1's signature GlowLogo,
 * smaller and static, layered over a compact variant-coloured aura that
 * carries the motion (rhythm / devotion / safety per screen).
 */
export function IntroMark({ variant }: IntroMarkProps) {
  const emerald = variant === 'cocoon';
  return (
    <div className="relative" style={{ width: 110, height: 110 }}>
      <IntroAura variant={variant} size={110} className="absolute inset-0" />
      {emerald && (
        <div
          aria-hidden
          className="absolute left-1/2 top-1/2 h-[72px] w-[72px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-emerald-400/35 blur-xl"
        />
      )}
      <div className="absolute inset-0 flex items-center justify-center">
        <GlowLogo size={56} pulse={false} tone={emerald ? 'emerald' : 'rose'} />
      </div>
    </div>
  );
}
